import moment from "moment";

export function convertResponseToJson(response){
    try{
        return response.json()
    } catch(e) {
        console.log("json conversion error: ", e);
        return {error:e}
    }
}

export function isObjectEmpty(obj) {
    if(!obj || obj.length === 0 ){
        return true
    } else {
        for(var prop in obj) {
            if(obj.hasOwnProperty(prop)) {
            return false;
            }
        }
    
        return JSON.stringify(obj) === JSON.stringify({});
    }   
}

export function isEmpty(str) {
    return (!str || str.length === 0 );
}

export function checkIfRedirect(data, history) {
    if(isObjectEmpty(data)){
        history.push(`${process.env.REACT_APP_SUB_ROUTE}`);
    }
}

export function transPasiiToRenewalData(pasiiData){
    const locationGp = pasiiData.permit.map((targetPermit)=>(targetPermit.location.map(locationGpMap)))
    .reduce((accumulator, currentValue) => (accumulator.concat(currentValue)))
    .filter((location, index, array)=>(array.findIndex((element)=>(
        element.district==location.district&&element.streetName==location.streetName&&element.streetNo==location.streetNo&&element.permitType.find((permit)=>(permit.selected)).id==location.permitType.find((permit)=>(permit.selected)).id
        ))==index));
    const vehicleGp = pasiiData.permit.map((targetPermit)=>(targetPermit.vehicle.map(vehicleGpMap))).reduce((accumulator, currentValue) => (accumulator.concat(currentValue)))
    .filter((vehicle, index, array)=>(array.findIndex((element)=>(element.vehicleRegNo==vehicle.vehicleRegNo))==index));
    const personalInfo = personalInfoMap(pasiiData);

    const permitInfo = {
        iWant: pasiiData.no_permit>=2?"bulk":"one",
        numPermit: pasiiData.no_permit,
        applicationReason: pasiiData.reason,
    }

    const renewalData = { ...personalInfo, ...permitInfo, locationGp, vehicleGp, oldEpasRefNum: pasiiData.epas_ref_num };
    console.log("renewalData: ", renewalData);
    return renewalData;
}

export function transPasiiToReplacementData(pasiiData){
    const locationGp = pasiiData.permit.map((targetPermit)=>(targetPermit.location.map(locationGpMap)))
    .reduce((accumulator, currentValue) => (accumulator.concat(currentValue)))
    .filter((location, index, array)=>(array.findIndex((element)=>(
        element.district==location.district&&element.streetName==location.streetName&&element.streetNo==location.streetNo&&element.permitType.find((permit)=>(permit.selected)).id==location.permitType.find((permit)=>(permit.selected)).id
        ))==index));
    const vehicleGp = pasiiData.permit.map((targetPermit)=>(targetPermit.vehicle.map(vehicleGpMap))).reduce((accumulator, currentValue) => (accumulator.concat(currentValue)))
    .filter((vehicle, index, array)=>(array.findIndex((element)=>(element.vehicleRegNo==vehicle.vehicleRegNo))==index));
    const dateTimeGp = pasiiData.permit.map((targetPermit)=>(targetPermit.period.map((period)=>(targetPermit.time.map((time)=>dateTimeGpMap(period, time)))).reduce((bigDateTimeGp, smallDateTimeGp)=>(bigDateTimeGp.concat(smallDateTimeGp)), []))).reduce((accumulator, currentValue) => (accumulator.concat(currentValue)))
    .filter((dateTime, index, array)=>(array.findIndex((element)=>(
        element.endTime==dateTime.endTime&&element.startTime==dateTime.startTime&&element.endDate.getTime()==dateTime.endDate.getTime()&&element.startDate.getTime()==dateTime.startDate.getTime()
        ))==index));;
    const personalInfo = personalInfoMap(pasiiData);

    const permitInfo = {
        iWant: pasiiData.no_permit>=2?"bulk":"one",
        numPermit: pasiiData.no_permit,
        applicationReason: pasiiData.reason,
    }

    const replacementData = { ...personalInfo, ...permitInfo, locationGp, vehicleGp, dateTimeGp, oldEpasRefNum: pasiiData.epas_ref_num };
    console.log("replacementData: ", replacementData);
    return replacementData;
}

export function transPasiiToDuplicateData(pasiiData){
    console.log("pasiiData: ", pasiiData);
    const locationGp = 
    pasiiData.permit.map((targetPermit)=>(targetPermit.location.map(locationGpMap)))
    .reduce((accumulator, currentValue) => (accumulator.concat(currentValue)))
    .filter((location, index, array)=>(array.findIndex((element)=>(
        element.district==location.district&&element.streetName==location.streetName&&element.streetNo==location.streetNo&&element.permitType.find((permit)=>(permit.selected)).id==location.permitType.find((permit)=>(permit.selected)).id
        ))==index));

        const vehicleGp = pasiiData.permit.map((targetPermit)=>(targetPermit.vehicle.map(vehicleGpMapForDuplicate))).reduce((accumulator, currentValue) => (accumulator.concat(currentValue)))
        .filter((vehicle, index, array)=>(array.findIndex((element)=>(element.vehicleRegNo==vehicle.vehicleRegNo))==index));
    const dateTimeGp = pasiiData.permit.map((targetPermit)=>(targetPermit.period.map((period)=>(targetPermit.time.map((time)=>dateTimeGpMap(period, time)))).reduce((bigDateTimeGp, smallDateTimeGp)=>(bigDateTimeGp.concat(smallDateTimeGp)), []))).reduce((accumulator, currentValue) => (accumulator.concat(currentValue)))
    .filter((dateTime, index, array)=>(array.findIndex((element)=>(
        element.endTime==dateTime.endTime&&element.startTime==dateTime.startTime&&element.endDate.getTime()==dateTime.endDate.getTime()&&element.startDate.getTime()==dateTime.startDate.getTime()
        ))==index));;
    const personalInfo = personalInfoMap(pasiiData);

    const permitInfo = {
        iWant: pasiiData.no_permit>=2?"bulk":"one",
        numPermit: pasiiData.no_permit,
        applicationReason: pasiiData.reason,
    }

    const duplicateData = { ...personalInfo, ...permitInfo, locationGp, vehicleGp, dateTimeGp, oldEpasRefNum: pasiiData.epas_ref_num };
    console.log("duplicateData: ", duplicateData);
    return duplicateData;
}

function personalInfoMap(pasiiData){
    return {
        applicantType: pasiiData.applicant_type=="Government"?"Government":pasiiData.applicant_type=="Non-government"?"Company":"Personal",
        personalTitle: pasiiData.applicant_title.toLowerCase().split('.')[0],
        lastName: '',
        firstName: pasiiData.applicant_first_name,
        chinName: pasiiData.applicant_chi_name,
        contactTitle: pasiiData.contact_title.toLowerCase().split('.')[0],
        contactPerson: pasiiData.contact_name,
        telNo: pasiiData.contact_tel,
        faxNo: pasiiData.contact_fax,
        email: pasiiData.contact_email,
        reenterEmail: pasiiData.contact_email,
        address: pasiiData.addr_room,
        floor: pasiiData.addr_floor,
        building: pasiiData.addr_building,
        street: pasiiData.addr_street,
        district: pasiiData.addr_district,
        companyName: pasiiData.applicant_company_name,
        department: pasiiData.govt_department_code
    }
}

function timeMap(time){
    return {
        startTime: time.start_at,
        endTime: time.end_at,
        recurrence: [{
            id: 'sunday',
            name: 'step3.dateTime.sunday',
            selected: time.recurrence.charAt(0)==1
        },
        {
            id: 'monday',
            name: 'step3.dateTime.monday',
            selected: time.recurrence.charAt(1)==1
        },
        {
            id: 'tuesday',
            name: 'step3.dateTime.tuesday',
            selected: time.recurrence.charAt(2)==1
        },
        {
            id: 'wednesday',
            name: 'step3.dateTime.wednesday',
            selected: time.recurrence.charAt(3)==1
        },
        {
            id: 'thursday',
            name: 'step3.dateTime.thursday',
            selected: time.recurrence.charAt(4)==1
        },
        {
            id: 'friday',
            name: 'step3.dateTime.friday',
            selected: time.recurrence.charAt(5)==1
        },
        {
            id: 'saturday',
            name: 'step3.dateTime.saturday',
            selected: time.recurrence.charAt(6)==1
        },
        {
            id: 'excludeHoliday',
            name: 'step3.dateTime.excludeHoliday',
            selected: time.except_holiday==1
        }]
    }
}

function dateTimeGpMap(period, time){
    return {
        ...timeMap(time),
        startDate: moment(period.start_date, "YYYY-MM-DD hh:mm:ss.S").toDate(),
        endDate: moment(period.end_date, "YYYY-MM-DD hh:mm:ss.S").toDate()
    }
}

function locationGpMap(loc){
    let permitTypeArr = loc.permit_type.split(',');
    let permitType = [{
        id: 'restricted',
        selected: permitTypeArr.includes('RZ')
    }, {
        id: 'prohibited',
        selected: permitTypeArr.includes('PZ')
    }, {
        id: 'bus',
        selected: permitTypeArr.includes('BL')
    }, {
        id: 'close',
        selected: permitTypeArr.includes('CR')
    }];
    return {
        district: loc.district,
        permitType: permitType,
        remarks: loc.remarks,
        streetName: loc.street_name,
        streetNo: loc.street_num
    }
}

function vehicleGpMap(veh){
    return {
        vehicleRegNo: veh.regmark,
        issueDate: ""
    }
}

function vehicleGpMapForDuplicate(veh){
    return {
        vehicleRegNo: veh.regmark,
        issueDate: null
    }
}

export function uploadFiles(files){
    const url = `${window.location.origin}/EPASService/file/multiUpload`;
    const formData = new FormData();
    files.forEach(file => {
        formData.append("file", file);
    });
    const option = {
        method: 'POST',
        body: formData
    }
    const result = fetch(url, option).then(response => response.json()).then(jsonObj => {
        if(jsonObj.message=="ok"){
            return jsonObj.fileResult.map(fileRes=>({fileId: fileRes.file_id, fileName: fileRes.file_name}))
        }
    }).catch(()=>null)
    return result
}

export function uploadBlob(blob, fileName){
    const url = `${window.location.origin}/EPASService/file/multiUpload`;
    const formData = new FormData();
    formData.append("file", blob, fileName);
    const option = {
        method: 'POST',
        body: formData
    }
    const result = fetch(url, option).then(response => response.json()).then(jsonObj => {
        if(jsonObj.message=="ok"){
            return jsonObj.fileResult.map(fileRes=>({fileId: fileRes.file_id, fileName: fileRes.file_name}))
        }
    }).catch(()=>null)
    return result
}

export function blobToFile(theBlob, fileName){
    return new File([theBlob], fileName, {type: "application/pdf"});
}

export function isRealDate(dateString){
    let [year, month, day] = dateString.split('-');
    year = parseInt(year);
    month = parseInt(month);
    day = parseInt(day);
    if(!isEmpty(year)&&!isNaN(year)){
        if (year<1950&&year>2100) {
            return false;
        }
    }
    if(!isEmpty(month)&&!isNaN(month)){
        if (month<1&&month>12) {
            return false;
        }
    }
    if(!isEmpty(day)&&!isNaN(day)){
        if (day<1&&day>31) {
            return false;
        }
    }
    return true;
}

export function isRealTime(timeString){
    let [hour, minute] = timeString.split(':');
    hour = parseInt(hour);
    minute = parseInt(minute);
}

const monthMaxDay = (month, year) => {
    switch (month) {
        case 1:
            return 31
        case 2:
            if(year%4===0){
                return 29
            }
            return 28
        case 3:
            return 31
        case 4:
            return 30
        case 5:
            return 31
        case 6:
            return 30
        case 7:
            return 31
        case 8:
            return 31
        case 9:
            return 30
        case 10:
            return 31
        case 11:
            return 30
        case 12:
            return 31
        default:
            return 31
    }
}

export function dateMask(newState, oldState, userInput, maskOptions){
    if(isEmpty(newState.value)){
        return newState
    }
    const [year, month, day] = newState.value.split("-");
    let targetYear = year, targetMonth = month, targetDay = day;
    let monthPadZero = false, dayPadZero = false;
    if (!(year?.includes("_"))) {
        if (year>2100) {
            targetYear = 2100;
        }
        if (year<1950) {
            targetYear = 1950;
        }
    }
    if (!(month?.includes("_"))) {
        if (month>12) {
            targetMonth = 12;
        }
        if (month<1){
            targetMonth = 1;
            monthPadZero = true;
        }
    }
    if (!(day?.includes("_"))){
        const maxDay = monthMaxDay(parseInt(targetMonth), parseInt(targetYear));
        if (day<1){
            targetDay = 1;
            dayPadZero = true;
        }
        if (day>maxDay){
            targetDay = maxDay;
        }
    }
    const result = {value: `${targetYear}-${monthPadZero?'0':''}${targetMonth}-${dayPadZero?'0':''}${targetDay}`, selection:newState.selection};
    return result
}

export function timeMask(newState, oldState, userInput, maskOptions){
    if(isEmpty(newState.value)){
        return newState
    }
    const [hour, minute] = newState.value.split(":");
    let targetHour = hour, targetMinute = minute;
    if (!(hour?.includes("_"))) {
        if (parseInt(hour)>23) {
            targetHour = 23;
        }
    }
    if (!(minute?.includes("_"))) {
        if (minute>59) {
            targetMinute = 59;
        }
    }
    const result = {value: `${targetHour}:${targetMinute}`, selection:newState.selection};
    return result
}

export function trimRegmark(vehicleGp){
    vehicleGp.forEach(vehicle =>{
        vehicle.vehicleRegNo = vehicle.vehicleRegNo.toUpperCase().replace(/\s/g,'');
    })

    return vehicleGp;
}